import gql from 'graphql-tag';

export const GET_ALL_ACCOUNTS = gql`
  query GetAccounts($limit: Int) {
    accounts(limit: $limit) {
      _id
      email
      name
    }
  }
`;

export const GET_ACCOUNTS_BY_SEARCH = gql`
  query GetAccountsBySearch($searchValue: String!, $limit: Int) {
    searchByNameAndEmail(input: { searchTerms: $searchValue, limit: $limit }) {
      response {
        _id
        name
        phone
        email
      }
    }
  }
`;

export const GET_ALL_ACCOUNTS_COMPANIES = gql`
  query GetAccountCompanies($accountId: ObjectId!) {
    account(query: { _id: $accountId }) {
      name
      email
    }
  }
`;

export const UPDATE_ACCOUNT = gql`
  mutation UpdateAccount($accountId: ObjectId!, $account: AccountUpdateInput!) {
    updateOneAccount(query: { _id: $accountId }, set: $account) {
      _id
      name
      email
    }
  }
`;

export const CREATE_ACCOUNT = gql`
  mutation CreateAccount($account: AccountInsertInput!) {
    insertOneAccount(data: $account) {
      _id
    }
  }
`;

export const GET_ONE_ACCOUNT = gql`
  query GetOneAccount($accountId: ObjectId!) {
    account(query: { _id: $accountId }) {
      _id
      name
      email
    }
  }
`;
